import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CalendarIcon } from 'lucide-react';
import { MeetingModal } from './MeetingModal';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 5000);
    return () => clearTimeout(timer);
  }, []);
  return <>
      <AnimatePresence data-id="element-29">
        {visible && !isOpen && <motion.button initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.9
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} onClick={() => setIsOpen(true)} className="flex items-center gap-2 bg-lime text-bg px-5 py-3 text-sm font-bold uppercase tracking-wide transition-transform duration-300 hover:scale-105 hover:brightness-110 focus:outline-none focus:ring-2 focus:ring-lime focus:ring-offset-2 focus:ring-offset-bg" data-id="element-30">
            <CalendarIcon size={16} data-id="element-31" />
            <span data-id="element-32">Termin vereinbaren</span>
          </motion.button>}
      </AnimatePresence>

      <MeetingModal isOpen={isOpen} onClose={() => setIsOpen(false)} data-id="element-33" />
    </>;
}